import { Pipe, PipeTransform } from '@angular/core';
import { PhotoDto } from '../../../models/trofaco/photoDto';
import { PhotoCollectionDto } from '../../../models/trofaco/photoCollectionDto';

@Pipe({
    name: 'previousPhotoId'
})
export class PreviousPhotoIdPipe implements PipeTransform {

    transform(photo?: PhotoDto, collection?: PhotoCollectionDto): string {
        if (photo == null) return '';
        if (collection == null) return photo.id;
        let index = collection.photos.indexOf(photo);
        if (index == -1) {
            console.error(`Can't find photo ${photo.id} in collection ${collection.title}`);
            return photo.id;
        }
        index--;
        if (index < 0) index = collection.photos.length - 1;
        return collection.photos[index].id;
    }

}
